import CollationPage from "./CollationPage";

export default CollationPage;